module.exports = __webpack_public_path__ + "media/images/avatar/29-fe4ea3ee94216c5c6efeca21f231defc.svg";